import api from './api';

// Validate size client-side (server max is 3 MB)
const MAX_SIZE = 3 * 1024 * 1024;

export const storage = {
    /**
     * Upload a file to the storage
     * 
     * @param {Blob} blob - The file to upload
     * @returns {Promise<{file_id: string}>} - The file_id
     */
    async uploadFile(blob) {
      if (blob.size > MAX_SIZE) {
        throw new Error('Content exceeds 3 MB limit');
      }

      // 1) Request presigned URL
      const presignRes = await api.post('/api/clipboard/presign', {
        content_type: blob.type,
        size: blob.size,
      });

      // Interceptor handles unified structure, response.data is already unwrapped
      const { file_id, upload_url } = presignRes.data;

      // 2) Upload to presigned URL
      const putRes = await fetch(upload_url, {
        method: 'PUT',
        headers: {
          'Content-Type': blob.type,
        },
        body: blob,
      });

      if (!putRes.ok) {
        throw new Error('Upload failed');
      }

      return {
        fileId: file_id,
      };
    }
}